<div class="dropdown">
  <div class="flex items-center justify-between dropdown-header">
    <div class="flex items-center">
      <div class="flex items-center justify-center dropdown-heading-icon">
        <mat-icon svgIcon="mat:person"></mat-icon>
      </div>
      <div class="dropdown-heading">David Smith</div>
    </div>

    <button
      [matMenuTriggerFor]="settingsMenu"
      mat-icon-button
      matTooltip="Settings"
      matTooltipPosition="before"
      type="button"
    >
      <mat-icon
        class="notifications-header-icon"
        svgIcon="mat:settings"
      ></mat-icon>
    </button>
  </div>

  <div class="dropdown-content">
    @for (item of items; track trackById($index, item)) {
      <a
        (click)="close()"
        [routerLink]="item.route"
        class="flex items-center notification"
        matRipple
      >
        <mat-icon
          [svgIcon]="item.icon"
          [ngClass]="item.colorClass"
          class="flex-none notification-icon"
        ></mat-icon>
        <div class="flex-auto">
          <div class="notification-label">{{ item.label }}</div>
          <div class="notification-description">{{ item.description }}</div>
        </div>
        <mat-icon
          class="flex-none notification-chevron"
          svgIcon="mat:chevron_right"
        ></mat-icon>
      </a>
    }
  </div>

  <div class="flex items-center justify-between dropdown-footer">
    <button
      [matMenuTriggerFor]="statusMenu"
      class="dropdown-footer-select"
      mat-button
      type="button"
    >
      @for (status of statuses; track trackById($index, status)) {
        @if (status === activeStatus) {
          <span>
            <mat-icon
              [ngClass]="status.colorClass"
              [svgIcon]="status.icon"
            ></mat-icon>
            <span>{{ status.label }}</span>
            <mat-icon
              class="dropdown-footer-select-caret"
              svgIcon="mat:arrow_drop_down"
            ></mat-icon>
          </span>
        }
      }
    </button>
    <a
      (click)="close()"
      [routerLink]="['/auth/login']"
      color="primary"
      mat-button
      >Logout</a
    >
  </div>
</div>

<mat-menu #statusMenu="matMenu" xPosition="before" yPosition="below">
  @for (status of statuses; track trackById($index, status)) {
    <button (click)="setStatus(status)" mat-menu-item>
      <mat-icon
        [ngClass]="status.colorClass"
        [svgIcon]="status.icon"
      ></mat-icon>
      <span>{{ status.label }}</span>
    </button>
  }
</mat-menu>

<mat-menu #settingsMenu="matMenu" xPosition="before" yPosition="below">
  <button mat-menu-item>
    <mat-icon svgIcon="mat:business"></mat-icon>
    <span>Change Address</span>
  </button>

  <button mat-menu-item>
    <mat-icon svgIcon="mat:verified_user"></mat-icon>
    <span>Change Username</span>
  </button>

  <button mat-menu-item>
    <mat-icon svgIcon="mat:lock"></mat-icon>
    <span>Change Password</span>
  </button>

  <button mat-menu-item>
    <mat-icon svgIcon="mat:notifications_off"></mat-icon>
    <span>Disable Notifications</span>
  </button>
</mat-menu>
